import { useMemo } from 'react';
export const useRecommendations = ({ sections }) => {
    const recommendations = useMemo(() => {
        const filteredSections = sections?.filter(({ group }) => ['Layout', 'Shop'].includes(group));
        if (!filteredSections)
            return [];
        const recommendedSections = filteredSections?.map(({ group, sections }) => {
            if (group === 'Layout') {
                return {
                    group,
                    sections: sections.filter((section) => ['hero', 'image-with-text', 'links-list'].includes(section.sectionType)),
                };
            }
            return {
                group,
                sections: sections.filter((section) => ['featured-collection', 'featured-product'].includes(section.sectionType)),
            };
        });
        return recommendedSections;
    }, [sections]);
    return {
        recommendations,
    };
};
